import {ChestMiniGameActions, IChestMiniGameState} from "./types";
import {Reducer} from "redux";
import {getType} from "typesafe-actions";
import * as actions from "./actions";

const initialState: IChestMiniGameState = {
    isFirstSelect: true,
    isRevealed: false,
    isWon: false,
    chestIndex: -1,
};

export const chestsReducer : Reducer<IChestMiniGameState, ChestMiniGameActions> = (state = initialState, action) => {
    switch (action.type) {
        case getType(actions.enterChestGame):
            return {
                ...state,
                isRevealed: false,
                isWon: false,
                chestIndex: -1,
            };

        case getType(actions.selectChest):
            return {
                ...state,
                isFirstSelect: false,
                isRevealed: true,
                isWon: action.payload.isWon,
                chestIndex: action.payload.chestIndex,
            };

        default:
            return state;
    }
};
